import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M30.57 23.54a12 12 0 11-12 12 12 12 0 0112-12m0-3a15 15 0 1015 15 15 15 0 00-15-15zM37.14 29a1.59 1.59 0 00-2.21-.23l-3.59 3.59a3.32 3.32 0 00-3.41 5.25 1.93 1.93 0 00.57.58 3.31 3.31 0 005.3-3.41l3.57-3.57a1.59 1.59 0 00-.23-2.21zm12-9.26h.28a5.43 5.43 0 10-5.09-7.31 5.39 5.39 0 00-.25 2.82 24.28 24.28 0 00-9.08-3.7v-1.8h1.49A2.5 2.5 0 0039 7.25V2.5A2.5 2.5 0 0036.49 0H24.65a2.5 2.5 0 00-2.5 2.5v4.75a2.5 2.5 0 002.5 2.5h1.49v1.8a24.44 24.44 0 1023 8.16zm-1.06-5.9a1.43 1.43 0 11.85 1.84 1.42 1.42 0 01-.86-1.87zM30.57 54A18.43 18.43 0 1149 35.57 18.45 18.45 0 0130.57 54z",
      stroke: "none"
    })]
  });
};
const IconGymFeaturePtAvailable = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "GymFeaturePtAvailable__IconGymFeaturePtAvailable",
  componentId: "sc-1hl9elp-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconGymFeaturePtAvailable };
